<template>
<div class="animated fadeIn">
  <Alerts ref="alert"/>
  <Forms ref="frmGroup"
      :title="this.$lang.MyAccount.TitleForm"
      :showHelp="true"
      :showSaveButton="true"
      v-on:Save="onSave">
    <!--Meu Perfil-->
    <div class="form-group row">
      <div class="col-md-12 pt-1">
        <h5 class="text-third"><i class="fa fa-user"></i> {{$lang.MyAccount.MyProfile}}</h5>
      </div>
    </div>
    <div class="form-group row pb-3">
      <!--* Nome-->
      <div class="col-md-4">
        <label for="txtName"><small class="text-danger">*</small> {{$lang.MyAccount.LabelName}}:</label>
        <div class="input-group">
          <b-form-input type="text"
                        :placeholder="$lang.MyAccount.PlaceholderEnterName"
                        v-model="form.nome.value"
                        :maxlength="form.nome.maxlength"
                        :required="form.nome.required"
                        :state="form.nome.state"></b-form-input>
        </div>
      </div>
      <!--* E-mail-->
      <div class="col-md-4">
        <label for="txtEmail"><small class="text-danger">*</small> {{$lang.MyAccount.LabelEmail}}:</label>
        <div class="input-group">
          <b-form-input type="email"
                        :placeholder="$lang.MyAccount.PlaceholderEnterEmail"
                        v-model="form.email.value"
                        :maxlength="form.email.maxlength"
                        :required="form.email.required"
                        :state="form.email.state"
                        ></b-form-input>
        </div>
      </div>
      <!--* Celular-->
      <div class="col-md-4">
        <label for="txtPhone"><small v-show="form.telefoneCelular.required" class="text-danger">*</small> {{$lang.MyAccount.LabelMobilePhone}}:</label>
        <div class="input-group">
          <b-form-input type="text"
                        name="txtPhone"
                        :placeholder="$lang.MyAccount.PlaceholderMobilePhone"
                        v-model="form.telefoneCelular.value"
                        :maxlength="form.telefoneCelular.maxlength"
                        :required="form.telefoneCelular.required"
                        :state="form.telefoneCelular.state"
                        v-mask="['(##) # ####-####']"></b-form-input>
        </div>
      </div>
      <!--Receber notificações por e-mail-->
      <div class="col-md-4">
        <br/>
        <b-form-checkbox v-model="data.enviaEmail" name="chkSendEmail">
          {{$lang.MyAccount.LabelCheckEmailNotification}}
        </b-form-checkbox>
      </div>
    </div>
    <!--Senha de acesso-->
    <div class="form-group row">
      <div class="col-md-12 pt-1">
        <h5 class="text-third"><i class="fa fa-lock"></i> {{$lang.MyAccount.AccessPasswords}}</h5>
      </div>
    </div>
    <div class="form-group row">
      <!-- <div class="col-md-4">
        <label for="txtPassword"><small class="text-info">*</small> {{$lang.MyAccount.LabelOldPassword}}:</label>
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <b-form-input type="password"
                        id="txtOldPassword"
                        name="txtOldPassword"
                        :placeholder="$lang.MyAccount.PlaceholderOldPassword"
                        v-model="form.senhaAntiga.value"
                        :maxlength="form.senhaAntiga.maxlength"
                        :required="form.senhaAntiga.required"
                        :state="form.senhaAntiga.state"></b-form-input>
        </div>
      </div> -->
      <!--* Senha-->
      <div class="col-md-4">
        <label for="txtPassword"><small class="text-info">*</small> {{$lang.MyAccount.LabelPassword}}:</label>
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <b-form-input type="password"
                        id="txtPassword"
                        name="txtPassword"
                        :placeholder="$lang.MyAccount.PlaceholderEnterPassword"
                        v-model="form.senhaNova.value"
                        :maxlength="form.senhaNova.maxlength"
                        :required="form.senhaNova.required"
                        :state="form.senhaNova.state"></b-form-input>
        </div>
      </div>
      <!--* Confirmação-->
      <div class="col-md-4">
        <label for="txtConfirmation"><small class="text-info">*</small> {{$lang.MyAccount.LabelConfirmation}}:</label>
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <b-form-input type="password"
                        id="txtConfirmation"
                        name="txtConfirmation"
                        :placeholder="$lang.MyAccount.PlaceholderConfirmationPassword"
                        v-model="form.confirmacao.value"
                        :maxlength="form.confirmacao.maxlength"
                        :required="form.confirmacao.required"
                        :state="form.confirmacao.state"></b-form-input>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <small class="text-third"><i class="fa fa-info-circle"></i> {{$lang.MyAccount.PasswordOnlyChange}}</small>
      </div>
    </div>
  </Forms>
</div>
</template>
<script>
import Profile from './profile.js'

export default Profile
</script>



// WEBPACK FOOTER //
// src/views/private/myaccount/profile/profile.vue